import { render, staticRenderFns } from "./PageMapping.vue?vue&type=template&id=71b966ea&"
import script from "./PageMapping.vue?vue&type=script&lang=js&"
export * from "./PageMapping.vue?vue&type=script&lang=js&"
import style0 from "./PageMapping.vue?vue&type=style&index=0&id=71b966ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports